export default __webpack_public_path__ + "static/media/edit.1a9de484.svg";